import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { MessageService } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../services/api.service';
import { init } from '../editorconfig';

@Component({
  selector: 'app-preliminary-discussion',
  standalone:false,
  templateUrl: './preliminary-discussion.component.html',
  styleUrl: './preliminary-discussion.component.scss'
})
export class PreliminaryDiscussionComponent implements OnInit , OnDestroy , AfterViewInit {
 @Input() id: any
  @Output() generatePDFEmitter = new EventEmitter<any>();
  commentForm: FormGroup;
  isEditorDisabled: boolean = false;
  init: EditorComponent['init'] = init;
  @Input() step: any;
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  @ViewChild('fileUpload') fileUpload!: FileUpload;
  @Output() stepCompleted = new EventEmitter<void>();
  @Input() isEditable: boolean = false
  @Input() stepDetails: any;
  @Input() schemeType: any;
  challengeForm: FormGroup;
  @Output() routeConfig: EventEmitter<any> = new EventEmitter();
  // @Output() routeConfig = new EventEmitter<any>();
  @Output() submitProposal: EventEmitter<any> = new EventEmitter();
  payload: {
    proposal_id: any;
    proposal_name: any;
  };
  uploadedUrl: any;
  apiUrl = environment.APIUrl;
  rfpdata: any;
  uploadedFileName: string = '';
  file: File;
  private subscriptions = new Subscription();
  userID: any;

  constructor(private fb: FormBuilder, private messageService: MessageService, private api: ApiService, private route: ActivatedRoute) {
    this.commentForm = this.fb.group({
      comment: ['', Validators.required],
    });
    const role = sessionStorage.getItem('user_role_id');
    this.userID = role;
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: any) => {
      const proposalId = params['id'];
      const proposalName = params['name'];
      this.payload = {
        proposal_id: proposalId,
        proposal_name: proposalName
      }
    });
    this.getRfpDetails();
console.log('step details ', this.stepDetails);
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  ngAfterViewInit() {
    setTimeout(() => {
      if (this.stepDetails?.can_edit ) {
        this.isEditorDisabled = false;
        this.commentForm.enable();
      } else {
        this.isEditorDisabled = true;
        this.commentForm.disable();
      }
      this.rebuildEditor()
    }, 3000);
  }
      editorReady = false;
  rebuildEditor() {
  this.editorReady = false; // destroy
  setTimeout(() => {
    this.init = this.getTinyInit(); // refresh config
    this.editorReady = true; // recreate editor
  }, 0);
}
getTinyInit(): EditorComponent['init'] {
  return {
    readonly: this.isEditorDisabled
  };
}
  goToNextStep() {
    this.stepCompleted.emit();
  }

  getRfpDetails(): void {
    let apiUrl = `/tdf/drdo-lab/?proposal_step=${this.id}&proposal_step__proposal=${this.payload.proposal_id}`;

    // Call API
    const sub = this.api.getAPI(apiUrl).subscribe((res: any) => {
      this.rfpdata = res[0];
      this.uploadedUrl =  this.rfpdata?.file ;
      this.commentForm.patchValue({
        comment: this.rfpdata?.mom
      });
    });
    this.subscriptions.add(sub);
  }

  onUpload(event: any): void {
    const file = event.files?.[0];
    this.uploadedFileName = file.name;
    this.file = file;
  }

  onSubmit(): void {
    const formData = new FormData();
    formData.append('proposal_step', this.step.id);
    formData.append('mom', this.commentForm.get('comment')?.value || '');

    if (this.file) {
      formData.append('file', this.file);
    }
    const baseUrl = `/tdf/drdo-lab/`;

    if (this.rfpdata?.id) {
      const sub = this.api.putAPI(`${baseUrl}${this.rfpdata.id}/`, formData).subscribe((res: any) => {
        this.uploadedFileName = ''
        this.fileUpload.clear();
        this.getRfpDetails();
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: res.message || 'MoM updated successfully'
        });
      });
      this.subscriptions.add(sub);
    } else {
      const sub = this.api.postAPI(baseUrl, formData).subscribe((res: any) => {
         this.uploadedFileName = ''
        this.fileUpload.clear();
        this.getRfpDetails();
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: res.message || 'MoM uploaded successfully'
        });
      });
    }
  }


  generatePDF() {
    const payload =  {
      url: '/revenue/need/version-control/',
      data: [
      { key: "Proposal Name", value: this.payload.proposal_name },
      { key: "Comment", value: this.commentForm.get('comment')?.value },
    ]
  }
    this.generatePDFEmitter.emit(payload);
  }

 getFileName(url: string): string {
  const fileName = url.split('/').pop() || 'Unknown File';
  return fileName.length > 50 ? fileName.substring(0, 50) + '...' : fileName;
}
  clearUpload(fileUpload: any) {
    this.uploadedFileName = null;
    this.uploadedUrl = null;
    fileUpload.clear();
  }



  
//    visible: boolean = false;
//   confirmChecked=false;

//   showConfirm() {
//       if (!this.visible) {
//           this.confirmChecked = false; // Reset checkbox when opening the modal
//           this.messageService.add({ key: 'confirm', sticky: true, severity: 'info', summary: 'Are you sure you want to submit this proposal?' });
//           this.visible = true;
//       }
//   }

//     onReject() {
//       this.messageService.clear('confirm');
//       this.visible = false;
//       this.confirmChecked = false; // Reset checkbox when closing the modal
//   }
// submitIRA() {
//   const iraPayload = {
//     proposal_step: this.id, // Using the component's id which seems to be proposal_step
//     // user: this.userID, // From your component
//     // user : parseInt(this.userID),
//     user : sessionStorage.getItem('user_id'),
//     approve_status: 1, // 1 for accept, 2 for reject
//     final_approval: this.confirmChecked ? 1 : 0, // Convert boolean to 1/0
//     remark: "", 
//     unit: sessionStorage.getItem('unit_id'),
    
//     // unit: this.challengeForm.get('coordinatingAgency')?.value || 2 // Using coordinating agency or default
//   };
//   console.log("unit id is", iraPayload.unit);
//   const sub = this.api.postAPI('/transaction/copy/proposal-ira-action/',
//     iraPayload
//   ).subscribe({
//     next: (response: any) => {
//       this.messageService.add({
//         severity: 'success',
//         summary: 'Success',
//         detail: 'IRA action submitted successfully',
//       });
//       // Emit the IRA data if needed by parent component
//       this.IRA.emit(response);
//       console.log('IRA submission response:', response);
//     },
//     error: (err) => {
//       console.error('IRA submission failed:', err);
//       this.messageService.add({
//         severity: 'error',
//         summary: 'Error',
//         detail: 'Failed to submit IRA action',
//       });
//     }
//   });
  
//   this.subscriptions.add(sub);
// }
//   onConfirm() {
//       this.messageService.clear('confirm');
//       this.visible = false;
//       this.onSubmit(); 
//       console.log("hiiiii")
//       this.submitIRA();
//       this.routeConfig.emit({isRouteConfig: true, isFinalApproval: this.confirmChecked});
//   }

 
//    routeconfig() {
//       console.log('routeconfig');
//       this.messageService.clear('confirm');
//       this.visible = false;
//       this.confirmChecked = false; // Reset checkbox when closing the modal
//       this.routeConfig.emit({isRouteConfig: false});
//   }

}
